import React from "react";
import VerifySvg from "../../../assets/verifyBatchSuccess.png";
import classes from "./whatsapp.module.css";
const Step4 = () => {
  return (
    <div className={classes.step4}>
      <div className={classes.step4_section1}>
        <div className={classes.successImg}>
          <img src={VerifySvg} alt="Success" />
        </div>
        <div className={classes.successTitle}>You are all set!</div>
        <div className={classes.successSubTitle}>Thank you for setting up your WhatsApp Healthcare Assistant. Your medicine reminders have been scheduled.</div>
      </div>
    </div>
  );
};

export default Step4;
